import { MetaTags } from 'approot/shared/helmet/helmet';
import { LayoutContentProps } from './layout-content';

export type Props = {
  pageMeta?: MetaTags;
  scrollToTop?: boolean;
  withFooter?: boolean;
  contentBackgroundColour?: string;
  isFooterVisibilityManaged?: boolean;
  triggerPageView?: boolean;
  isFullPageHeight?: boolean;
  hideSmallSearch?: boolean;
} & LayoutContentProps;

export type LayoutProps = {
  setIsEndOfContent: (is: boolean) => void;
  isEndOfContent?: boolean;
  isScrollUpVisible?: boolean;
} & Props;

export type BackgroundImageUrls = {
  base: string;
  l: string;
  xl: string;
  xxl: string;
  xxxl: string;
};

export const CONTENT_PAGE_ACTION_BAR = 'content-page-action-bar';
export const LAYOUT_MAIN_ID = 'main';
export const LAYOUT_NAVIGATION_ID = 'navigation';
export const LAYOUT_SEARCH_ID = 'search';
export const LAYOUT_NOTIFICATIONS_ID = 'notifications';

export const LAYOUT_REGION_HEADER_Z_INDEX = 103;
export const LAYOUT_HEADER_Z_INDEX = 102;
